import Text from '../text'
import { Dictionary } from '@/localization/dictionary'

interface SearchEmptyResultProps {
  searchInput: string
  dict?: Dictionary['searchView']['noResults']
}

const SearchEmptyResult = ({ searchInput, dict }: SearchEmptyResultProps) => {
  return (
    <div className="animate-fade-in text-center text-white">
      <Text as="p" className="mb-2 mt-8 text-xl sm:text-2xl" lineHeight={26}>
        {(dict?.title || 'There are no results for "{searchInput}"').replace(
          '{searchInput}',
          searchInput,
        )}
      </Text>

      <Text as="p" variant="primary">
        {dict?.subtitle || 'Try again using a different spelling or keywords.'}
      </Text>
    </div>
  )
}

export default SearchEmptyResult
